import { motion } from 'framer-motion'
import { Twitter } from 'lucide-react'
import logoUrl from '#app/assets/logo.svg'
import { Button } from './ui/button'

export function MapHud() {
	const handleJoinClick = () => {
		// Redirect to OAuth flow
		window.location.href = '/auth/twitter'
	}

	return (
		<motion.div
			initial={{ x: -100, opacity: 0 }}
			animate={{ x: 0, opacity: 1 }}
			transition={{ duration: 0.3, ease: 'easeOut', delay: 2 }}
			className="fixed top-4 z-30 mx-4 max-w-2xl rounded-lg border border-white/10 bg-black/40 p-4 px-4 shadow-[0_0_30px_rgba(139,92,246,0.15)] backdrop-blur-md sm:p-6"
		>
			<div className="mb-4 flex items-center">
				<img src={logoUrl} alt="IndieWorld Logo" className="h-12 w-12" />
				<span
					className="text-primary ml-3 text-2xl font-bold"
					style={{ position: 'relative', top: '1px' }}
				>
					Indie World
				</span>
			</div>
			<h1 className="text-primary mb-2 text-xl font-bold">
				Connect with Indie Hackers Near You.
			</h1>
			<p className="mb-6 text-sm text-gray-300">
				Place yourself on the map and see who's building from around the world.
			</p>
			<Button
				onClick={handleJoinClick}
				className="w-full bg-gradient-to-r from-purple-600 to-pink-600 font-semibold text-white shadow-[0_0_20px_rgba(139,92,246,0.3)] transition-all hover:shadow-[0_0_30px_rgba(139,92,246,0.5)]"
			>
				<Twitter className="mr-2 h-4 w-4" />
				Add me to the Map (via X)
			</Button>
		</motion.div>
	)
}
